<template>
    <div class="contactContent column">
        <el-image :src="require('@/assets/image/contact01.png')" fit="cover" class="dlTop"></el-image>
        <div class="dlText">第<span class="dlNum">1</span>步：扫码下方二维码，进入<span>微信小程序</span></div>
        <el-image :src="contactCode" fit="cover" class="dlCode"></el-image>
        <div class="dlText">第<span class="dlNum">2</span>步：打开小程序后，点击右下方的<span>我的页面</span></div>
        <el-image :src="require('@/assets/image/contact02.png')" fit="cover" class="dlImg"></el-image>
        <div class="dlText">第<span class="dlNum">3</span>步：点击<span>联系客服</span>就可以咨询客服问题了</div>
        <el-image :src="require('@/assets/image/contact03.png')" fit="cover" class="dlImg"></el-image>
    </div>
</template>
<script>
    export default{
        data(){
            return{
                contactCode: ''
            }
        },
        created(){
            this.getContact()
        },
        methods: {
           // 获取二维码
           getContact(){
                this.request.get("index/user/kefu",{
                    params:{

                    }
                })
                .then(res=>{
                    this.contactCode = res.data
                })
            }, 
        }
    }
</script>
<style lang="less" scoped>
    .contactContent{
        width: 100%;
        padding: 82px 0;
        .dlTop{
            width: 439px;
            height: 55px;
        }
        .dlText{
            padding: 70px 0 52px 0;
            font: 18px/28px "Microsoft YaHei";
            color: #464646;
            .dlNum{
                font: 28px/28px "Microsoft YaHei";
                font-style:italic;
            }
            span{
                color: #FF6A00;
            }
        }
        .dlCode{
            width: 235px;
            height: 235px;
        }
        .dlImg{
            width: 278px;
        }
    }
</style>